// import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

import {
  addAuthInterceptor,
  // removeAuthInterceptor,
} from '../../services/httpRequest';

const authCookie: string = process.env.REACT_APP_COOKIE_NAME!;

const ProtectedRoute = ({
  children,
}: {
  children: React.ReactElement;
}): JSX.Element => {
  const [cookies] = useCookies([authCookie]);
  const token = cookies[authCookie];

  if (!token) {
    const referralUri = encodeURIComponent(window.location.href);
    const loginRedirectUri = `${process.env.REACT_APP_SITE_URL}/auth/login?from=${referralUri}`;
    window.location.href = loginRedirectUri;
  }

  addAuthInterceptor(token);

  return children;
};

export default ProtectedRoute;
